module.exports = __webpack_public_path__ + "img/exe.e8c6edcf.png";